import { IconButton, styled } from '@mui/material';
import { IconButtonProps } from '@mui/material/IconButton';
import { red, yellow } from '@mui/material/colors';
interface ActionsIconButtonProps extends IconButtonProps {
  small?: boolean;
}

export const ActionsIconButton = styled(IconButton)<ActionsIconButtonProps>(
  ({ small, theme }) => ({
    '& .MuiSvgIcon-root': {
      fontSize: small ? '1.25rem' : '1.5rem',
      [theme.breakpoints.down('lg')]: {
        fontSize: small ? '1rem' : '1.25rem',
      },
    },
    cursor: 'pointer',
    '&:hover': {
      background: 'linear-gradient(114.04deg, #52489C 3.25%, #8F78F0 100%)',
      color: 'white',
    },
  })
);
